import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => setLogs([]));
  }, []);

  if (!logs) return <Skeleton className="h-64 bg-white/5" />;

  return (
    <div className="space-y-6" data-testid="admin-audit-page">
      <div>
        <p className="section-label">Security</p>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-white tracking-tight mt-1">Audit Logs</h2>
        <p className="text-sm text-slate-400 mt-2">Every administrative action is recorded with timestamp and actor.</p>
      </div>

      <div className="card-surface overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead>
              <tr className="text-left text-[10px] tracking-widest text-slate-500 uppercase border-b border-white/5 bg-secondary/20">
                <th className="px-5 py-3.5">Timestamp</th><th className="px-5 py-3.5">Admin</th>
                <th className="px-5 py-3.5">Action</th><th className="px-5 py-3.5">Target</th>
                <th className="px-5 py-3.5">Details</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {logs.length === 0 && (
                <tr><td colSpan={5} className="px-5 py-10 text-center text-slate-500">No audit events yet.</td></tr>
              )}
              {logs.map((l) => (
                <tr key={l.id} className="text-slate-300" data-testid="audit-row">
                  <td className="px-5 py-3 font-mono text-xs whitespace-nowrap">
                    {new Date(l.timestamp).toLocaleString("en-ZA", { timeZone: "Africa/Johannesburg" })}
                  </td>
                  <td className="px-5 py-3 text-xs">{l.admin_email}</td>
                  <td className="px-5 py-3"><span className="text-[10px] font-bold tracking-widest px-2 py-1 rounded bg-blue-600/10 text-blue-300 border border-blue-500/25">{l.action}</span></td>
                  <td className="px-5 py-3 text-white">{l.target}</td>
                  <td className="px-5 py-3 text-xs text-slate-500">{l.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
